import { FunctionComponent, useState } from 'react';
import styles from './PricingWithRadio.module.scss';
import classNames from 'classnames';
import RadioSwitch from '../../inputs/RadioSwitch/RadioSwitch';
import HowRocketFuelWorksPopUp from '../../popups/HowRocketFuelWorksPopUp/HowRocketFuelWorksPopUp';
import NavigationLink from '../../links/NavigationLink/NavigationLink';
import Label from '../../texts/Label/Label';

const testData = [
  {
    value: '100',
    label: 'None',
    discountAmount: '0%',
    description:
      'Share your upside with us and we’ll share your risk. Grant equity to Astronomic and receive steep site-wide discounts.',
  },
  {
    value: '85',
    label: '1%',
    discountAmount: '12%',
    description: 'Grant 1% equity to Astronomic and receive a 12% site-wide discount.',
  },
  {
    value: '70',
    label: '2%',
    discountAmount: '24%',
    description: 'Grant 2% equity to Astronomic and receive a 24% site-wide discount.',
  },
  {
    value: '55',
    label: '3%',
    discountAmount: '36%',
    description: 'Grant 3% equity to Astronomic and receive a 36% site-wide discount.',
  },
];

interface PricingWithRadioProps {
  radioName: string;
  style?: any;
}

const PricingWithRadio: FunctionComponent<PricingWithRadioProps> = ({ radioName, style }) => {
  const [selected, setSelected] = useState(testData[0].value);
  const [popUpActive, setPopUpActive] = useState(false);

  const isDiscounted = () => {
    return testData[0].value !== selected;
  };

  const getElementByValue = () => {
    return testData.find((item) => item.value === selected);
  };

  return (
    <>
      <div className={styles['container']} style={style}>
        <div className={styles['price-group']}>
          {isDiscounted() && (
            <p className={styles['price-group__discount']}>
              <Label text={getElementByValue()?.discountAmount as string} visualStyle="small" />
            </p>
          )}

          <p
            className={classNames(
              styles['price-group__number'],
              isDiscounted() && styles['price-group__number--discount'],
              'text text--h3'
            )}
          >
            ${selected}
          </p>
          <p className={classNames(styles['price-group__property'], 'text text--caption')}>/hour</p>
        </div>

        <p className={classNames(styles['text-1'], 'text text--body-3 text--bold')}>
          Maximize your savings. Grant equity for discounts:
        </p>

        <RadioSwitch
          className={styles['radio']}
          name={radioName}
          onChange={setSelected}
          options={testData}
          selected={selected}
        />

        <p className={classNames(styles['text-2'], 'text text--caption')}>
          {getElementByValue()?.description}{' '}
          <NavigationLink path="#" onClick={() => setPopUpActive(true)}>
            Learn more
          </NavigationLink>
          .
        </p>
      </div>

      <HowRocketFuelWorksPopUp whatIsPopUpActive={popUpActive} changeWhatIsPopUpActiveState={setPopUpActive} />
    </>
  );
};

export default PricingWithRadio;
